import { useState } from "react";
import { faqData, faqTopics } from "./data"; // Adjust path as needed

const FaqPage = () => {
  const [selectedTopic, setSelectedTopic] = useState("General");
  const [open, setOpen] = useState(null);

  const toggleAnswer = (index) => {
    setOpen(open === index ? null : index);
  };

  return (
    <>

      <section
        className="flex flex-col justify-center items-center space-y-6 lg:h-[656px] md:h-[656px] h-[852px] bg-cover bg-center"
        style={{
          backgroundImage: "url('/images/FAQ/Background.webp')",
        }}
      >
        <h4 className="text-xl sm:text-2xl md:text-2xl font-semibold  font-lora text-center text-lime-500">
          FAQ
        </h4>
        <h1 className=" lora-display text-[#151515] px-[55px] font-lora text-center">
          Frequently Asked Questions
        </h1>
        <p className=" text-center  outfit-text  text-black  px-[18px]">
          Find answers to inquiries about getting started, features, data security, integrations,<br className="hidden lg:inline" />support, customization, and more.
        </p>
       
  <div className="relative w-[332px] md:w-[500px] lg:w-[580px]">
  {/* Search Icon */}
   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"  className="absolute left-4 top-1/2 transform -translate-y-1/2 h-[16px] w-[16px] lg:h-[20px] lg:w-[20px]">
<path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#5F5F5F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.5001 17.5L13.9167 13.9166" stroke="#5F5F5F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  {/* Input Field */}
  <input
    type="text"
    placeholder="  Search Questions "
    className="w-full p-3 pl-12 pr-14 rounded-[10px] text-sm shadow-lg focus:outline-none focus:ring-2 focus:ring-[#10B981]"
  />
</div>
      </section>






      <section className="flex flex-col items-center lg:h-[806px] md:h-[900px]  lg:px-[106px] md:px-[64px]  px-4 py-12 bg-white">
      <div className="w-full lg:w-[1300px] md:w-[706px] flex flex-col md:flex-row justify-between items-start gap-8">
        <div className="w-full md:w-1/2  lg:px-0 px-2 ">
          <h2 className="text-black text-start text-2xl font-lora mb-4">Topics</h2>
          <input
            type="text"
            placeholder="General"
            value={selectedTopic}
            onChange={(e) => {
              setSelectedTopic(e.target.value);
              setOpen(null);
            }}
            className="lg:w-[490px] lg:h-[56px] p-3 mb-6 border border-[#75AD53] rounded-[8px] text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#75AD53]"
          />
          
          <div className="space-y-[16px]">
            {faqTopics
              .filter((topic) => topic !== "General")
              .map((topic, index) => (
                <h3
                  key={index}
                  className={`cursor-pointer outfit-text transition duration-200 ${
                    selectedTopic === topic
                      ? "text-lime-600 font-bold"
                      : "text-black hover:text-lime-600"
                  }`}
                  onClick={() => {
                    setSelectedTopic(topic);
                    setOpen(null); 
                  }}
                >
                  {topic}
                </h3>
              ))}
          </div>
        </div>
        <div className="w-full md:w-1/2 flex flex-col gap-8">
          <div className="p-6 bg-gray-50 rounded-2xl shadow-lg">
            {(faqData[selectedTopic] || []).map((faq, index) => (
              <div key={index} className="mb-6 border-b pb-4">
                <div
                  className="cursor-pointer flex justify-between items-center"
                  onClick={() => toggleAnswer(index)}
                >
                  <h3 className="text-[12px]  font-outfit  md:text-[14px] lg:text-[16px] font-normal">{faq.question}</h3>
                  <span className="text-gray-500">{open === index ? '▲' : '▼'}</span>
                </div>
                {open === index && (
                  <p className=" mt-2 outfit-text">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>

          {/* Technical Support Section */}
          <div className="bg-gray-100 p-6 rounded-2xl shadow-md flex flex-col items-start">
            <h2 className="text-[12px] md:text-[14px] lg:text-[16px] font-outfit font-medium">Technical Support</h2>
            <p className=" outfit-text mt-2">
              If you need help or have any technical questions, feel free to reach out to us. Our team is available 24/7 to assist you.
            </p>
            <a
              href="mailto:homes@znorm.org"
              className="mt-4 flex items-center bg-lime-700 text-white px-6 py-2 rounded-full hover:bg-lime-600 transition duration-200"
            >
              Email
            </a>
          </div>
        </div>
      </div>
    </section>

    </>
  );
};

export default FaqPage;
